module.exports = __webpack_public_path__ + "img/br.63e89a9c.png";